import { Brand, createBranded } from '@deltasierra/type-utilities';

export type ReportingPublishedTemplateCategoryId = Brand<number, 'ReportingPublishedTemplateCategoryId'>;
export const ReportingPublishedTemplateCategoryId = createBranded<ReportingPublishedTemplateCategoryId>();
